import { Box, Divider, Typography } from '@mui/material';
import { labels } from '../../data/constants';
import AccountCompleteModal from '../../Components/CommonComponents/accountCompleteModal/AccountComplete';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useRef, useState } from 'react';
import BusinessPlanHeader from '../../Components/BusinessPlan/businessPlanHeader';
import IdeaSelectorComp from '../../Components/BusinessPlan/ideaSelectorComp';
import { getBusinessIdeasService } from '../../Services/businessIdeasService';
import {
  bnp_saveAnswerService,
  getIdeaDetailsService,
} from '../../Services/businessPlanServices';
import TabWithScore from '../../Components/CommonComponents/TabWithScore/TabWithScore';
import ProfileSkeleton from '../../Components/Profile/ProfileSkeleton';
import ProfileTabSkeleton from '../../Components/Profile/ProfileTabSkeleton';
import IdeaTabContent from '../../Components/BusinessPlan/ideaTabContent';
import { aiAutofillService } from '../../Services/ideaDetailService';
import { saved, saving, couldnotSave, resetStatus } from '../../redux/saveSlice';
import { logChanges } from '../../Services/commentService';

const BusinessPlanComp = () => {
  const id = useRef('');
  const dispatch = useDispatch();
  const userRole = useSelector((state) => state?.userDetails?.role);
  const userWorkspace = useSelector(
    (state) => state?.loginUserData?.user?.selectedWorkspace
  );
  const selectedIdeaDetails = useSelector(
    (state) => state?.researchData?.selectedIdea
  );
  const ideaList = useSelector(
    (state) => state?.researchData?.ideasList
  );
  const [showAccountPrompt, setShowAccountPrompt] = useState(false);
  const [tabs, setTabs] = useState([]);
  const [tabsCopy, setTabsCopy] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [activeIdea, setActiveIdea] = useState(null);
  const [businessPlanScore, setBusinessPlanScore] = useState(null);
  useEffect(() => {
    if (userRole) {
      setShowAccountPrompt(false);
    }
  }, [userRole]);
  useEffect(() => {
    setTabsCopy([]);
    fetchIdeaList();
    fetchIdeaDetails(selectedIdeaDetails?.id);
  }, [userWorkspace, selectedIdeaDetails]);
  useEffect(() => {
    if (selectedIdeaDetails?.id) {
      submitAnswer(13, "This section will be auto-generated when you export the report. It will be based on the Sub-Category and Competitor data you detail on the Research page for this idea.");
    }
  }, [selectedIdeaDetails]);
  const fetchIdeaList = async () => {
    try {
      if (!userWorkspace?.id) {
        return;
      }
      const payload = {
        workspaceId: +userWorkspace.id,
      };
      await getBusinessIdeasService(payload, dispatch);
    } catch (e) {
      console.log(e);
    }
  };
  const fetchIdeaDetails = async (receivedIdeaId) => {
    id.current = receivedIdeaId;
    try {
      if (!receivedIdeaId) return;
      let payload = {
        workspaceid: userWorkspace?.id,
        ideaid: receivedIdeaId,
      };
      setShowLoader(true);
      setBusinessPlanScore(null);
      const response = await getIdeaDetailsService(payload);
      if (!response && response?.length === 0) {
        return;
      }
      let tabData = [];
      response?.forEach((tabItem) => {
        let answeredQuestion = 0;
        for (let i = 0; i < tabItem.questions.length; i++) {
          if (tabItem.questions[i].answer !== null) {
            if (tabItem.questions[i]?.type === 'multiSelect') {
              let answerStringInArray = tabItem.questions[i].answer.split(',');
              let answerArray = [];
              answerStringInArray.forEach((item) => {
                if (item !== ' ') {
                  let answerLabel;
                  tabItem?.questions[i]?.options?.forEach((option) => {
                    if (option?.value === item) {
                      answerLabel = option?.label;
                    }
                  });
                  answerArray.push({ label: answerLabel, value: item });
                }
              });
              tabItem.questions[i].answer = answerArray;
              if (answerArray.length !== 0) {
                answeredQuestion++;
              }
            } else {
              if (tabItem.questions[i].answer !== ' ') {
                answeredQuestion++;
              }
            }
          }
          if (tabItem.questions[i]?.interDependentQuestion !== null) {
            let dependencyStatus = isDependencyFulfilled(
              response,
              tabItem.questions[i]?.interDependentQuestion
            );

            tabItem.questions[i].isDependencyFullfilled = dependencyStatus;
          }
        }
        let tabDataItem = {
          ...tabItem,
          completionPercentage:
            (answeredQuestion / tabItem.questions.length) * 100,
        };
        tabData.push(tabDataItem);
      });
      let businessPlanScore = calculateOverallScore(tabData);
      let stringifiedData = JSON.stringify(tabData);
      setBusinessPlanScore(businessPlanScore);
      setTabs(JSON.parse(stringifiedData));
      setTabsCopy(JSON.parse(stringifiedData));
      setActiveIdea(receivedIdeaId);
      setShowLoader(false);
    } catch (e) {
      console.log(e);
      setShowLoader(false);
    }
  };
  const tabChangeHandler = (event, tabInfo) => {
    setActiveTab(tabInfo);
  };
  const handleDataChange = (questionId, answerReceived) => {
    let tabData = [...tabsCopy];
    tabData.forEach((tabItem) => {
      tabItem.questions.forEach((questionItem) => {
        if (questionItem.id === questionId) {
          questionItem.answer = answerReceived;
        }
      });
    });
    setDependencyFulfilled(questionId, answerReceived, tabData);
  };
  const TabCompletionPercentage = (tabData) => {
    let tabDataCoppy = [];
    tabData?.forEach((tabItem) => {
      let answeredQuestion = 0;
      for (let i = 0; i < tabItem.questions.length; i++) {
        if (tabItem.questions[i].answer !== null) {
          if (tabItem.questions[i]?.type === 'multiSelect') {
            let answerStringInArray = tabItem.questions[i].answer.split(',');
            let answerArray = [];
            answerStringInArray.forEach((item) => {
              if (item !== ' ') {
                let answerLabel;
                tabItem?.questions[i]?.options?.forEach((option) => {
                  if (option?.value === item) {
                    answerLabel = option?.label;
                  }
                });
                answerArray.push({ label: answerLabel, value: item });
              }
            });
            tabItem.questions[i].answer = answerArray;
            if (answerArray.length !== 0) {
              answeredQuestion++;
            }
          } else {
            if (tabItem.questions[i].answer !== ' ') {
              answeredQuestion++;
            }
          }
        }
      }
      let tabDataItem = {
        ...tabItem,
        completionPercentage:
          (answeredQuestion / tabItem.questions.length) * 100,
      };
      tabDataCoppy.push(tabDataItem);
      let businessPlanScore = calculateOverallScore(tabDataCoppy);
      setBusinessPlanScore(businessPlanScore);
      setTabsCopy([...tabDataCoppy]);
    });
  };

  const isDependencyFulfilled = (tabData, questionId) => {
    let dependencyStatus;
    tabData.forEach((tabItem) => {
      tabItem.questions.forEach((question) => {
        if (question?.id === questionId) {
          let answer = question?.answer?.trim();
          if (answer) {
            dependencyStatus = true;
          } else {
            dependencyStatus = false;
          }
        }
      });
    });
    return dependencyStatus;
  };

  const setDependencyFulfilled = (questionId, answerReceived, tabData) => {
    if (!answerReceived) {
      TabCompletionPercentage(tabData);
    }
    tabData.forEach((tabItem) => {
      tabItem.questions.forEach((question) => {
        if (
          question.interDependentQuestion !== null &&
          question.interDependentQuestion === questionId
        ) {
          if (!answerReceived) {
            question.isDependencyFullfilled = false;
          } else {
            question.isDependencyFullfilled = true;
          }
        }
      });
    });
    TabCompletionPercentage(tabData);
  };
  const checkAnswerChange = (questionId, answer) => {
    let isAnswerChanged;
    //looping through each tab.
    tabs.forEach((tabItem) => {
      tabItem.questions.forEach((questionItem) => {
        if (questionItem.id === questionId) {
          if (Array.isArray(answer)) {
            //Stringifying it to compare
            if (
              JSON.stringify(questionItem.answer) === JSON.stringify(answer)
            ) {
              isAnswerChanged = false;
              return;
            } else {
              isAnswerChanged = true;
              return;
            }
          } else {
            if (questionItem.answer === answer) {
              isAnswerChanged = false;
              return;
            } else {
              isAnswerChanged = true;
              return;
            }
          }
        }
      });
    });
    return isAnswerChanged;
  };
  const calculateOverallScore = (tabsCopy) => {
    let overAllscore = 0;
    let tabsCompletionScore = 0;
    let tabsLength = tabsCopy.length;
    tabsCopy.forEach((tab) => {
      tabsCompletionScore += tab.completionPercentage;
    });
    overAllscore = Math.round(tabsCompletionScore / tabsLength);
    return overAllscore;
  };
  const submitAnswer = async (questionId, answer) => {
    try {
      let isAnswerChanged = checkAnswerChange(questionId, answer);
      if (isAnswerChanged !== true) {
        return;
      }
      let overallScore = calculateOverallScore(tabsCopy);
      const payload = {
        questionId,
        answer: answer || ' ',
        workspaceId: userWorkspace?.id,
        ideaId: activeIdea,
        businessPlanScore: Math.round(overallScore),
      };
      dispatch(saving());
      const response = await bnp_saveAnswerService(payload, dispatch);
      if (response) {
        dispatch(saved());
        const matchingIdea = ideaList.find(
          (option) => option.id === activeIdea
        );
        let changeLogPayload = {
          changeDetail: `Idea '${matchingIdea.label}' updated`,
          workspaceId: userWorkspace.id,
        };
        await logChanges(changeLogPayload, dispatch);
      }
      // if (questionId >= 8 && questionId <= 12) {
      //   overallScore = ((1 / tabsCopy[2].questions.length) * 100) + 2;
      //   console.log(overallScore);
      //   const tempPayload = {
      //     questionId: 13,
      //     answer: 'Test',
      //     workspaceId: userWorkspace?.id,
      //     ideaId: activeIdea,
      //     businessPlanScore: Math.round(overallScore),
      //   };
      //   await bnp_saveAnswerService(tempPayload, dispatch);
      // }
    } catch (e) {
      dispatch(couldnotSave());
      setTimeout(() => {
        dispatch(resetStatus());
      }, 10000);
      console.log(e);
    }
  };

  const initiateAiAutoFill = async (questionId, isPro, question) => {
    try {
      let payload = {
        ideaId: +id.current,
        autofill_field: question,
        isPro: isPro,
      };
      dispatch(saving());
      const response = await aiAutofillService(payload, dispatch);
      if (response) {
        dispatch(saved());
        handleDataChange(questionId, response);
        submitAnswer(questionId, response);
        const matchingIdea = ideaList.find(
          (option) => option.id === activeIdea
        );
        let changeLogPayload = {
          changeDetail: `Idea '${matchingIdea.label}' updated`,
          workspaceId: userWorkspace.id,
        };
        await logChanges(changeLogPayload, dispatch);
        return response;
      }
    } catch (e) {
      dispatch(couldnotSave());
      setTimeout(() => {
        dispatch(resetStatus());
      }, 10000);
      console.log(e);
    }
  };
  return (
    <Box mt={2} ml={2} mr={2} pb={3}>
      <BusinessPlanHeader
        selectedIdea={activeIdea}
        userWorkspace={userWorkspace?.id}
      />
      <IdeaSelectorComp />

      <Divider sx={{ marginTop: 3 }} />
      {tabsCopy.length === 0 && !showLoader && (
        <Typography
          component={'h2'}
          mt={5}
          fontSize={24}
          fontWeight={'bold'}
          textAlign={'center'}
        >
          {labels.businessPlan.selectAnIdea}
        </Typography>
      )}
      {tabsCopy.length !== 0 && !showLoader && (
        <Box className="borderBottom2 borderColorGrey">
          <TabWithScore
            tabData={tabsCopy}
            handleTabChange={tabChangeHandler}
            selectedTab={activeTab}
          />
        </Box>
      )}
      {tabsCopy.length !== 0 && (
        <IdeaTabContent
          ideaId={activeIdea}
          tabQuestions={tabsCopy[activeTab]?.questions.sort(
            (a, b) => a?.sortby - b?.sortby
          )}
          tabDataHandler={handleDataChange}
          submitAnswer={submitAnswer}
          aiAutoFill={initiateAiAutoFill}
          businessPlanScore={businessPlanScore}
          isDisabled={
            userWorkspace?.role === 'guest'
              ? userWorkspace?.workspacePrivelege === 'commenter'
                ? true
                : false
              : false
          }
        />
      )}
      {showLoader && (
        <Box className="mt2">
          <ProfileTabSkeleton />
          <ProfileSkeleton />
        </Box>
      )}
      {!showAccountPrompt && (
        <AccountCompleteModal showDialog={showAccountPrompt} close={false} />
      )}
    </Box>
  );
};

export default BusinessPlanComp;
